'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var clearSelection = function (element) {
    $(element).closest('.dropdown, .dropdown-item').children('.dropdown-menu, .menu-list').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show, .dropdown-item.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show, .dropdown-item.show').removeClass('show');
    $(element).closest('li').detach();
};

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                } else if (menuItem.prev().length === 0) {
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().parent().children().first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
            function () {
                return $(this).parent();
            }
        );

    $('.dropdown:not(.disabled) [data-toggle="dropdown"], a.has-sub-cat')
        .on('click', function (e) {
            if (!isDesktop(this)) {
                $('.modal-background').show();
                // copy parent element into current UL
                var li = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                li.append(link);
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                if ($(this).hasClass('has-sub-cat')) {
                    $(this).closest('.dropdown-item').find('> .menu-list')
                    .prepend(li)
                    .prepend(closeMenu);
                    // copy navigation menu into view
                    $(this).closest('.dropdown-item').addClass('show');
                } else {
                    $(this).parent().children('.dropdown-menu')
                    .prepend(li)
                    .prepend(closeMenu);
                    // copy navigation menu into view
                    $(this).parent().addClass('show');
                }
                $(this).attr('aria-expanded', 'true');
                e.preventDefault();
            }
        })
        .on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (isDesktop(this)) {
                if (!$(this).parent().hasClass('show')) {
                    $('.nav-item.dropdown.show').each(function () { $(this).removeClass('show'); });
                    $('.nav-item.dropdown a[aria-expanded="true"]').each(function () { $(this).attr('aria-expanded', 'false'); });
                    $('.dropdown-menu.show').each(function () { $(this).removeClass('show'); });
                    $(this).parent().addClass('show');
                    $(this).next('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                } else {
                    $(this).parent().removeClass('show');
                    $(this).next('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                }
            }
            $('.search-container').hide();
            $('.header').removeClass('search-active');
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggleable-left, .navbar-header').removeClass('in');
        $('.modal-background').hide();
        $('body').removeClass('menu-in');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left, .navbar-header').removeClass('in');
        $('.modal-background').hide();
        $('body').removeClass('menu-in');
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $('.main-menu, .navbar-header').toggleClass('in');
        if ($('body').hasClass('menu-in')) {
            $('.modal-background').hide();
            $('body').removeClass('menu-in');
        } else {
            $('.modal-background').show();
            $('body').addClass('menu-in');
        }
        $('.search-container').hide();
        $('.header').removeClass('search-active');
    });

    // Detect click outside megamenu while it's opened, then close
    $('html').click(function (event) {
        if (isDesktop(this) && $(event.target).hasClass('modal-background')) {
            if ($('body').hasClass('menu-in')) {
                $('.navbar-toggler').click();
            }
        }
    });

    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.children('a').first().next().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function ($popover) { // escape
                $(this).focus();
                $popover.removeClass('show');
            },
            9: function ($popover) { // tab
                $popover.removeClass('show');
            }
        },
        function () {
            var $popover = $('.user .popover');
            if (!($popover.hasClass('show'))) {
                $popover.addClass('show');
            }
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
    });


    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 30;
    var navbarHeight = $('nav#main-nav').outerHeight();

    // Check if the user has scrolled and apply classes depning on direction
    var hasScrolled = function () {
        var st = $(document).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }

        /* If they scrolled down and are past the navbar, add class .nav-up.
        ** This is necessary so you never see what is "behind" the navbar.
        */
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('nav#main-nav').removeClass('header-down').addClass('header-up');
            $('.search-container').removeClass('nav-visible').addClass('nav-hidden');
        } else if (st + $(window).height() < $(document).height()) {
            // Scroll Up
            $('nav#main-nav').removeClass('header-up').addClass('header-down');
            $('.search-container').removeClass('nav-hidden').addClass('nav-visible');
        }
        lastScrollTop = st;
    };

    $(window).scroll(function () {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            $('.nav-item.dropdown.show').each(function () { $(this).removeClass('show'); });
            $('.dropdown-menu.show').each(function () { $(this).removeClass('show'); });
            // $('nav#main-nav').removeClass('see-thru');
            hasScrolled();
            didScroll = false;
        } else if ($(document).scrollTop() === 0) {
            // This is for pages that do not have enough content to scroll,
            // or their dynamic content removes the ability to scroll while the nav is hidden
            $('nav#main-nav').removeClass('header-up').addClass('header-down');
            $('.search-container').removeClass('nav-hidden').addClass('nav-visible');
        }
    }, 250);
};
